import {PUBLISH_IN_PROGRESS, PUBLISH_IN_PROGRESS_FINISHED} from '../actions/types';

const INITIAL_STATE = false;


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PUBLISH_IN_PROGRESS:
            return true;
        case PUBLISH_IN_PROGRESS_FINISHED:
            return false;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/PublishInProgressReducer.js